import { render } from "./ProgressionPanel.vue?vue&type=template&id=07f20f56&scoped=true"
import script from "./ProgressionPanel.vue?vue&type=script&lang=js"
export * from "./ProgressionPanel.vue?vue&type=script&lang=js"

import "./ProgressionPanel.vue?vue&type=style&index=0&id=07f20f56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f20f56"]])

export default __exports__